import { useQuery } from '@tanstack/react-query';

import { isSupabaseConfigured } from '@/config';
import { getAppConfig, type AppConfig } from '@/lib/data/provider';
import { queryKeys } from '@/lib/data/keys';

/**
 * Server-published version targets for the in-app update gate. Config changes
 * rarely (a human bumps it in the dashboard when a new store build ships), so a
 * long staleTime keeps this to ~one fetch per launch — the gate decision is made
 * once on mount, not polled. Disabled (and harmless) when the backend isn't
 * configured; the gate then no-ops.
 */
export function useAppConfig() {
  return useQuery<AppConfig>({
    queryKey: queryKeys.appConfig,
    queryFn: getAppConfig,
    // Effectively "fetch once per launch": treat as fresh for an hour and never
    // surface an error state — getAppConfig already resolves to SAFE defaults.
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 1,
    refetchOnWindowFocus: false,
    enabled: isSupabaseConfigured,
  });
}
